import React, { useState } from "react";
import { api, errMsg, fmtNum } from "@finance/lib/api";
import { toast } from "sonner";
import { Button } from "@finance/components/ui/button";
import { Input } from "@finance/components/ui/input";

export function LoanScheduleEditor({ detail, onSaved }) {
  const paid = (detail.repayments || []).length;
  const sched = detail.schedule || [];
  const [edit, setEdit] = useState(false);
  const [amts, setAmts] = useState([]);
  const start = () => { setAmts(sched.slice(paid).map((s) => String(s.amount))); setEdit(true); };
  const sum = amts.reduce((a, v) => a + (Number(v) || 0), 0);
  const ok = Math.abs(sum - Number(detail.outstanding || 0)) < 0.01;
  const save = async () => {
    try { const { data } = await api.put(`/payroll/advances/${detail.id}/schedule`, { amounts: amts.map((v) => Number(v) || 0) }); toast.success("Schedule updated"); setEdit(false); onSaved?.(data); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mt-4" data-testid="loan-schedule">
      <div className="mb-1 flex items-center justify-between">
        <div className="lx-label text-gray-500">Planned Schedule (month by month)</div>
        {detail.status === "Active" && !edit && <Button size="sm" variant="outline" className="h-7 text-xs" data-testid="edit-schedule-btn" onClick={start}>Edit monthly amounts</Button>}
      </div>
      <table className="w-full text-xs"><thead className="bg-gray-50"><tr className="lx-label"><th className="px-2 py-1 text-left">#</th><th className="px-2 py-1 text-left">Period</th><th className="px-2 py-1 text-right">Amount</th></tr></thead>
        <tbody>{sched.map((s, i) => (
          <tr key={s.seq} className="border-b border-gray-100">
            <td className="px-2 py-1">{s.seq}</td><td className="px-2 py-1">{s.period}{i < paid && <span className="ml-1 text-emerald-600">· repaid</span>}</td>
            <td className="px-2 py-1 text-right font-mono-num">
              {edit && i >= paid
                ? <Input type="number" className="ml-auto h-7 w-28 text-right text-xs" data-testid={`sched-amt-${i}`} value={amts[i - paid]} onChange={(e) => { const n = [...amts]; n[i - paid] = e.target.value; setAmts(n); }} />
                : fmtNum(s.amount)}
            </td>
          </tr>))}
        </tbody>
      </table>
      {edit && (
        <div className="mt-2 flex flex-wrap items-center gap-2 text-xs">
          <Button size="sm" variant="outline" className="h-7 text-xs" data-testid="sched-add-month" onClick={() => setAmts([...amts, "0"])}>+ Month</Button>
          <span className={ok ? "text-emerald-700" : "text-red-600"} data-testid="sched-sum">Remaining months total {fmtNum(sum)} / outstanding {fmtNum(detail.outstanding)} {ok ? "✓" : "— must match"}</span>
          <Button size="sm" className="ml-auto h-7 bg-[#1B4383] text-xs" disabled={!ok} data-testid="sched-save" onClick={save}>Save schedule</Button>
          <Button size="sm" variant="ghost" className="h-7 text-xs" onClick={() => setEdit(false)}>Cancel</Button>
        </div>
      )}
    </div>
  );
}
